import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhimashankarcab() {



  const cardData =
  {
    keyword: 'Mumbai to Bhimashankar Cab ',
    heading: 'Shambhu Cabs: Mumbai to Bhimashankar Cab  ',
    headingDescription: 'Shambhu Cabs provides reliable Mumbai to Bhimashankar Cab services, offering safe, comfortable, and seamless travel for pilgrims, families, tourists, and corporate travelers heading to the famous Bhimashankar Temple. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey through the scenic Western Ghats with clean, well-maintained vehicles and trained chauffeurs. With flexible one-way and round-trip options, 24/7 booking assistance, and doorstep pickup from South Mumbai to Thane, Borivali to Navi Mumbai, Shambhu Cabs makes your pilgrimage or weekend trip convenient and stress-free. Whether you’re visiting Bhimashankar for darshan, trekking, or a nature getaway, Shambhu Cabs delivers dependable Mumbai to Bhimashankar cab services with comfort, punctuality, and complete reliability.',

    top: 'Top Places to Visit in Bhimashankar with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Temple is one of the 12 sacred Jyotirlingas of Lord Shiva and the main attraction of the region. Surrounded by the dense Sahyadri forests, the ancient stone temple features intricate Nagara-style architecture and powerful spiritual ambience. Pilgrims visit year-round to seek blessings in this holy abode of Shiva."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "This lush wildlife sanctuary is home to the endangered Giant Squirrel (Shekru), numerous bird species, and diverse flora and fauna. Dense forests, waterfalls, viewpoints, and trekking routes make it a paradise for nature lovers and wildlife enthusiasts."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a peaceful natural lake surrounded by greenery and frequented by monkeys, birds, and scenic forest views. A short walk from the temple, it offers a calm environment ideal for relaxation, photography, and enjoying nature."
  },
  {
    "title": "Nagphani Point (Duke’s Nose)",
    "description": "Nagphani Point, also known as Duke’s Nose, offers breathtaking panoramic views of the Sahyadri mountains. The trek to this viewpoint passes through dense forests and rocky patches, making it a favorite destination for trekkers and adventure seekers."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Located deep within the Bhimashankar forest, Gupt Bhimashankar is believed to be a natural formation of a Shivalinga created by water currents. Surrounded by serene wilderness, the spot has mythological significance and offers a peaceful spiritual experience."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat is a scenic mountain pass known for its dramatic landscapes, deep valleys, and tribal village culture. It is also one of the most stunning trekking routes in the region, offering mesmerizing views of the Konkan plains."
  },
  {
    "title": "Matheran Viewpoint (Bhimashankar Route)",
    "description": "A hidden gem on the Bhimashankar forest route, this viewpoint offers distant views of Matheran’s mountain ranges. The peaceful surroundings, cool winds, and panoramic scenery make it an excellent stop for nature lovers."
  },
  {
    "title": "Bhorgiri Fort",
    "description": "Bhorgiri Fort is an ancient hill fort located near Bhimashankar. The trek to the fort passes through forests, streams, and tribal villages. The remaining fortifications and peaceful surroundings make it a great spot for history and trekking enthusiasts."
  }
],


"services": [
  {
    "name": "Mumbai Bhimashankar Taxi",
    "description": "Mumbai Bhimashankar Taxi provides reliable, safe, and comfortable travel for passengers journeying from Mumbai to Bhimashankar. Perfect for families, solo travelers, and groups visiting the famous Bhimashankar Temple or the surrounding wildlife sanctuary, this service offers well-maintained vehicles, professional drivers, and timely pickups. Passengers can enjoy a smooth highway journey, scenic views along the route, and options for both sedans and SUVs based on their travel needs."
  },
  {
    "name": "One-Way Cab Mumbai to Bhimashankar",
    "description": "One-Way Cab Mumbai to Bhimashankar is ideal for travelers who require single-direction travel. Whether for a temple visit, pilgrimage, or day trip, this service ensures punctual pickups, well-kept vehicles, and professional chauffeurs familiar with the route. The one-way option provides an economical and convenient alternative for visitors who do not require a return trip immediately."
  },
  {
    "name": "Bhimashankar Darshan Cab Mumbai",
    "description": "Bhimashankar Darshan Cab Mumbai caters to pilgrims and tourists planning a trip to Bhimashankar Temple. This service combines comfort with convenience, offering vehicles suitable for families, solo travelers, and small groups. Professional drivers guide the journey, ensuring timely arrival for temple darshan and providing a relaxed and safe travel experience."
  },
  {
    "name": "Mumbai to Bhimashankar Temple Cab",
    "description": "Mumbai to Bhimashankar Temple Cab specializes in temple visits and spiritual journeys. Passengers benefit from timely pickups, clean and well-maintained vehicles, and experienced drivers who know the best routes to Bhimashankar. The service ensures a smooth travel experience, whether for a day trip or an overnight stay near the temple area."
  },
  {
    "name": "Mumbai Bhimashankar Car Rental",
    "description": "Mumbai Bhimashankar Car Rental offers flexible and affordable car hire services for travelers heading to Bhimashankar. Customers can choose from sedans, SUVs, or premium vehicles with experienced drivers, ensuring comfort and safety throughout the journey. Ideal for day trips, weekend getaways, and temple visits, this service provides convenience and reliability for all passengers."
  },
  {
    "name": "SUV Cab Mumbai Bhimashankar",
    "description": "SUV Cab Mumbai Bhimashankar caters to groups and families requiring spacious and comfortable vehicles for their Bhimashankar trip. Equipped with modern amenities, safety features, and professional drivers, these SUVs ensure a smooth and enjoyable ride on highways and hilly roads. Perfect for weekend trips, sightseeing, or pilgrimage tours."
  },
  {
    "name": "Sedan Taxi Mumbai Bhimashankar",
    "description": "Sedan Taxi Mumbai Bhimashankar provides an economical and comfortable option for small groups or solo travelers. With professional chauffeurs, well-maintained vehicles, and flexible booking options, passengers can enjoy a smooth journey from Mumbai to Bhimashankar for temple visits, forest trips, or hill sightseeing excursions."
  },
  {
    "name": "Mumbai Bhimashankar Forest Cab",
    "description": "Mumbai Bhimashankar Forest Cab is designed for travelers planning a visit to the Bhimashankar wildlife sanctuary or surrounding forest areas. The service offers well-maintained SUVs and sedans, experienced drivers familiar with the routes, and convenient pickups. Passengers can explore the natural beauty of Bhimashankar with comfort and safety."
  },
  {
    "name": "Affordable Cab Mumbai Bhimashankar",
    "description": "Affordable Cab Mumbai Bhimashankar provides budget-friendly options for travelers seeking cost-effective intercity transport. The service maintains high standards of vehicle quality, safety, and punctuality while offering competitive pricing. Ideal for families, students, and pilgrims visiting Bhimashankar on a limited budget."
  },
  {
    "name": "Best Cab Mumbai to Bhimashankar",
    "description": "Best Cab Mumbai to Bhimashankar is known for its superior vehicle fleet, punctual service, and professional chauffeurs. Offering a range of cars from sedans to SUVs, this service ensures a hassle-free and comfortable journey, catering to tourists, pilgrims, and corporate travelers heading to Bhimashankar."
  },
  {
    "name": "24×7 Mumbai Bhimashankar Taxi",
    "description": "24×7 Mumbai Bhimashankar Taxi provides round-the-clock taxi services for passengers traveling to Bhimashankar. Whether it is early morning temple visits or late-night returns, the service ensures timely pickups, safe travel, and professional drivers available at any hour. Passengers benefit from flexibility, convenience, and peace of mind."
  },
  {
    "name": "Mumbai Bhimashankar Tour Cab",
    "description": "Mumbai Bhimashankar Tour Cab is perfect for travelers planning a comprehensive tour of Bhimashankar, including temple visits, forest exploration, and hill sightseeing. With knowledgeable drivers, comfortable vehicles, and flexible itineraries, passengers can enjoy a safe and memorable travel experience."
  },
  {
    "name": "Bhimashankar Hills Cab Mumbai",
    "description": "Bhimashankar Hills Cab Mumbai caters to travelers exploring the scenic hills of Bhimashankar. This service provides comfortable SUVs or sedans with trained drivers experienced in hilly terrain. Passengers can enjoy a safe, smooth, and relaxing journey while taking in the natural beauty of Bhimashankar hills."
  },
  {
    "name": "Express Highway Cab Bhimashankar",
    "description": "Express Highway Cab Bhimashankar offers fast and convenient travel via highway routes from Mumbai to Bhimashankar. Ideal for time-sensitive trips, temple visits, or weekend getaways, this service ensures well-maintained vehicles, professional chauffeurs, and timely arrivals for a seamless travel experience."
  },
  {
    "name": "Mumbai Bhimashankar Outstation Cab",
    "description": "Mumbai Bhimashankar Outstation Cab provides reliable intercity travel with options for round trips or one-way travel. Vehicles are equipped for comfort and safety, while professional drivers ensure a smooth journey. This service is ideal for tourists, pilgrims, and families seeking hassle-free Bhimashankar travel."
  },
  {
    "name": "Fast Cab Mumbai Bhimashankar",
    "description": "Fast Cab Mumbai Bhimashankar focuses on speedy and efficient intercity travel. Passengers benefit from highway-optimized routes, professional drivers, and well-maintained vehicles. Perfect for travelers who want to reach Bhimashankar quickly without compromising comfort or safety."
  },
  {
    "name": "Mumbai Bhimashankar Pickup Drop",
    "description": "Mumbai Bhimashankar Pickup Drop service offers door-to-door transportation between Mumbai and Bhimashankar. The service includes timely pickups, clean vehicles, professional chauffeurs, and flexible scheduling, making it ideal for temple visits, forest trips, and weekend getaways with ease and convenience."
  }
],

"tableData": [
  ["Mumbai Bhimashankar Taxi", "One-Way Cab Mumbai to Bhimashankar"],
  ["Bhimashankar Darshan Cab Mumbai", "Mumbai to Bhimashankar Temple Cab"],
  ["Mumbai Bhimashankar Car Rental", "SUV Cab Mumbai Bhimashankar"],
  ["Sedan Taxi Mumbai Bhimashankar", "Mumbai Bhimashankar Forest Cab"],
  ["Affordable Cab Mumbai Bhimashankar", "Best Cab Mumbai to Bhimashankar"],
  ["24×7 Mumbai Bhimashankar Taxi", "Mumbai Bhimashankar Tour Cab"],
  ["Bhimashankar Hills Cab Mumbai", "Express Highway Cab Bhimashankar"],
  ["Mumbai Bhimashankar Outstation Cab", "Fast Cab Mumbai Bhimashankar"],
  ["Mumbai Bhimashankar Pickup Drop", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Bhimashankar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Bhimashankar cab services, perfect for pilgrimage trips, nature visits, and peaceful getaways to the Bhimashankar Temple."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and well-maintained cabs designed to provide a smooth and comfortable journey through the ghats."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Forest Routes",
    "WhyChoosedescription": "Our skilled drivers are experienced with the Mumbai to Bhimashankar forest and ghat routes, ensuring safe, smooth, and reliable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Bhimashankar cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel inquiries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Pilgrimage Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Bhimashankar travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every journey, ensuring a hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Bhimashankar journey smooth, safe, and stress-free."
  }
]



















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Bhimashankar cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Bhimashankar cab services with experienced and professional drivers.',
  },
  {
    question: 'How can I book a Mumbai to Bhimashankar cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Bhimashankar cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars ideal for traveling from Mumbai to Bhimashankar.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Bhimashankar route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the hilly terrain and routes leading to Bhimashankar, ensuring a safe trip.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Bhimashankar cab?',
    answer: 'Absolutely. You can choose any preferred pickup point in Mumbai and drop-off location near or at the Bhimashankar Temple.',
  },
  {
    question: 'Is the Mumbai to Bhimashankar cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Bhimashankar cab booking services for your convenience.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Bhimashankar cab bookings?',
    answer: 'All vehicles undergo regular sanitization, and our drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Bhimashankar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Bhimashankar journey?',
    answer: 'Yes, our 24x7 customer support team is always available to assist you throughout your Mumbai to Bhimashankar trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vijay Shinde',
    feedback: 'Our Mumbai to Bhimashankar trip with Shambhu Cabs was safe and comfortable. Excellent service and polite driver!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'Highly reliable Mumbai to Bhimashankar cab service. Smooth ride and very professional support from Shambhu Cabs.',
    rating: 5,
  },
];











































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-bhimashankar-cab.jpg",
  "description": "Shambhu Cabs offers reliable Mumbai to Bhimashankar cab services with clean vehicles, professional drivers, and affordable fares. Book one-way or round-trip taxis for Bhimashankar Temple darshan, forest routes, hills travel, or outstation journeys. Choose from sedan, SUV, or premium cars for a safe and comfortable ride.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-bhimashankar-cab"
  }
};








  return (
    <div>
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Safe Temple Darshan Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Bhimashankar cab with Shambhu Cabs. Affordable fares, clean cars, and expert drivers for one-way and round-trip travel. Ideal for Bhimashankar Temple darshan, forest routes, and hill journeys. Available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Bhimashankar Taxi, One-Way Cab Mumbai to Bhimashankar, Bhimashankar Darshan Cab Mumbai, Mumbai to Bhimashankar Temple Cab, Mumbai Bhimashankar Car Rental, SUV Cab Mumbai Bhimashankar, Sedan Taxi Mumbai Bhimashankar, Mumbai Bhimashankar Forest Cab, Affordable Cab Mumbai Bhimashankar, Best Cab Mumbai to Bhimashankar, 24×7 Mumbai Bhimashankar Taxi, Mumbai Bhimashankar Tour Cab, Bhimashankar Hills Cab Mumbai, Express Highway Cab Bhimashankar, Mumbai Bhimashankar Outstation Cab, Fast Cab Mumbai Bhimashankar, Mumbai Bhimashankar Pickup Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhimashankarcab;